module.exports = __webpack_public_path__ + "img/6.6e14e5b9.png";